import { render, staticRenderFns } from "./AddUpdateWhoWeAre.vue?vue&type=template&id=59f0ec3a"
import script from "./AddUpdateWhoWeAre.vue?vue&type=script&lang=js"
export * from "./AddUpdateWhoWeAre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports